import dynamic from "next/dynamic";
const VoiceAgent11LabsEmbeddedComponent = dynamic(()=>import("./voice-agent-11labs-embedded-component"));
import VoiceAgent11LabsEmbeddedConfig, { VoiceAgent11LabsEmbeddedAdvancedConfig } from "./voice-agent-11labs-embedded-config";
export default {
    VoiceAgent11LabsEmbeddedComponent,
    VoiceAgent11LabsEmbeddedConfig,
    VoiceAgent11LabsEmbeddedAdvancedConfig
};
